<div class="text-center modal-header" [class.with-cross]="cross">
  <mat-icon *ngIf="cross" (click)="close.emit(true)">close</mat-icon>
  <span class="title">{{ title | translate }}</span>
</div>
